// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';
import { LINKEDIN } from '@/lib/socialProfile';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const postClicksHistoryConfig = {
    title: 'chart.linkedin.post_click_history',
    margin: { left: -10, right: 25 },
    name: {
        date: 'date',
        value: 'chart.linkedin.post_click_history_name',
        avg: 'chart.linkedin.avg_post_click_history'
    },
    id: 'clicks_history',
    social: LINKEDIN,
    color: {
        value: 'purple',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.facebook.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
